export default {
    black: '#000000',
    white: '#FFFFFF',
    gray: {
        50: '#F7FAFC',
        100: '#EDF2F7',
        200: '#E2E8F0',
        300: '#CBD5E0',
        400: '#A0AEC0',
        500: '#718096',
        600: '#4A5568',
        700: '#2D3748',
        800: '#1A202C',
        900: '#171923',
    },
    red: {
        50: '#FDE8E8',
        100: '#F9BEBE',
        200: '#F59393',
        300: '#F16969',
        400: '#EE3F3F',
        500: '#F91616',
        600: '#BB1111',
        700: '#8C0D0D',
        800: '#5E0808',
        900: '#2F0404',
    },
    orange: {
        50: '#FEEFE7',
        100: '#FBD3BC',
        200: '#F9B790',
        300: '#F69A65',
        400: '#F37E39',
        500: '#F1620E',
        600: '#C14E0B',
        700: '#913B08',
        800: '#602706',
        900: '#301403',
    },
    yellow: {
        50: '#FEFBE6',
        100: '#FCF3BA',
        200: '#FBEB8E',
        300: '#F9E362',
        400: '#F7DB36',
        500: '#F7D92B',
        600: '#C5A907',
        700: '#937F06',
        800: '#625404',
        900: '#312A02',
    },
    green: {
        50: '#EAFBEF',
        100: '#C3F4D2',
        200: '#9CEDB4',
        300: '#75E597',
        400: '#4FDE7A',
        500: '#2ED861',
        600: '#20AC4A',
        700: '#188138',
        800: '#105625',
        900: '#082B13',
    },
    teal: {
        50: '#E6FFFA',
        100: '#B2F5EA',
        200: '#81E6D9',
        300: '#4FD1C5',
        400: '#38B2AC',
        500: '#319795',
        600: '#2C7A7B',
        700: '#285E61',
        800: '#234E52',
        900: '#1D4044',
    },
    blue: {
        50: '#E6EBFE',
        100: '#BAC8FD',
        200: '#8EA5FB',
        300: '#6182FA',
        400: '#266CD3',
        500: '#093CF6',
        600: '#0730C5',
        700: '#052391',
        800: '#031863',
        900: '#020C31',
    },
    cyan: {
        50: '#E5FDFF',
        100: '#B8F8FF',
        200: '#8AF4FF',
        300: '#5CF0FF',
        400: '#2EECFF',
        500: '#00E2F9',
        600: '#00B9CC',
        700: '#008B99',
        800: '#005D66',
        900: '#002E33',
    },
    purple: {
        50: '#FBE9FB',
        100: '#F5C2F5',
        200: '#EE9BEE',
        300: '#E773E7',
        400: '#E14CE1',
        500: '#DA25DA',
        600: '#A51CA5',
        700: '#831683',
        800: '#570F57',
        900: '#2C072C',
    },
    pink: {
        50: '#FFF5F7',
        100: '#FED7E2',
        200: '#FBB6CE',
        300: '#F687B3',
        400: '#ED64A6',
        500: '#D53F8C',
        600: '#B83280',
        700: '#97266D',
        800: '#702459',
        900: '#521B41',
    },
    apex: {
        black: '#000000',
        coral: '#EE3F3F',
        cornflowerBlue: '#266cd3',
        darkCyan: '#008b99',
        darkGray: '#A0AEC0',
        darkOrange: '#F1620E',
        darkSlateBlue: '#052391',
        darkSlateGray: '#718096',
        deepSkyBlue: '#00E2F9',
        dimGray: '#4A5568',
        forestGreen: '#188138',
        gainsboro: '#EDF2F7',
        ghostWhite: '#F7FAFC',
        gold: '#F7D92B',
        goldenRod: '#F69A65',
        gray: '#718096',
        green: '#20AC4A',
        indigo: '#831683',
        lemonChiffon: '#FCF3BA',
        lightGray: '#E2E8F0',
        lightSlateGray: '#A0AEC0',
        lightYellow: '#FEFBE6',
        link: '#266cd3',
        midnightBlue: '#000000',
        orange: '#F37E39',
        orangeRed: '#F91616',
        rebeccaPurple: '#A51CA5',
        seaGreen: '#2C7A7B',
        silver: '#CBD5E0',
        slateBlue: '#6A5ACD',
        slateGray: '#0730C5',
        steelBlue: '#00B9CC',
        white: '#FFFFFF',
        whiteSmoke: '#F7FAFC',
        yellow: '#FBEB8E',
    },
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29sb3JzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vLi4vLi4vLi4vYXBleC1vbmxpbmUvY29tcG9uZW50LWxpYnJhcnkvdGhlbWUvZm91bmRhdGlvbnMvY29sb3JzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLGVBQWU7SUFDYixLQUFLLEVBQUUsU0FBUztJQUNoQixLQUFLLEVBQUUsU0FBUztJQUNoQixJQUFJLEVBQUU7UUFDSixFQUFFLEVBQUUsU0FBUztRQUNiLEdBQUcsRUFBRSxTQUFTO1FBQ2QsR0FBRyxFQUFFLFNBQVM7UUFDZCxHQUFHLEVBQUUsU0FBUztRQUNkLEdBQUcsRUFBRSxTQUFTO1FBQ2QsR0FBRyxFQUFFLFNBQVM7UUFDZCxHQUFHLEVBQUUsU0FBUztRQUNkLEdBQUcsRUFBRSxTQUFTO1FBQ2QsR0FBRyxFQUFFLFNBQVM7UUFDZCxHQUFHLEVBQUUsU0FBUztLQUNmO0lBQ0QsR0FBRyxFQUFFO1FBQ0gsRUFBRSxFQUFFLFNBQVM7UUFDYixHQUFHLEVBQUUsU0FBUztRQUNkLEdBQUcsRUFBRSxTQUFTO1FBQ2QsR0FBRyxFQUFFLFNBQVM7UUFDZCxHQUFHLEVBQUUsU0FBUztRQUNkLEdBQUcsRUFBRSxTQUFTO1FBQ2QsR0FBRyxFQUFFLFNBQVM7UUFDZCxHQUFHLEVBQUUsU0FBUztRQUNkLEdBQUcsRUFBRSxTQUFTO1FBQ2QsR0FBRyxFQUFFLFNBQVM7S0FDZjtJQUNELE1BQU0sRUFBRTtRQUNOLEVBQUUsRUFBRSxTQUFTO1FBQ2IsR0FBRyxFQUFFLFNBQVM7UUFDZCxHQUFHLEVBQUUsU0FBUztRQUNkLEdBQUcsRUFBRSxTQUFTO1FBQ2QsR0FBRyxFQUFFLFNBQVM7UUFDZCxHQUFHLEVBQUUsU0FBUztRQUNkLEdBQUcsRUFBRSxTQUFTO1FBQ2QsR0FBRyxFQUFFLFNBQVM7UUFDZCxHQUFHLEVBQUUsU0FBUztRQUNkLEdBQUcsRUFBRSxTQUFTO0tBQ2Y7SUFDRCxNQUFNLEVBQUU7UUFDTixFQUFFLEVBQUUsU0FBUztRQUNiLEdBQUcsRUFBRSxTQUFTO1FBQ2QsR0FBRyxFQUFFLFNBQVM7UUFDZCxHQUFHLEVBQUUsU0FBUztRQUNkLEdBQUcsRUFBRSxTQUFTO1FBQ2QsR0FBRyxFQUFFLFNBQVM7UUFDZCxHQUFHLEVBQUUsU0FBUztRQUNkLEdBQUcsRUFBRSxTQUFTO1FBQ2QsR0FBRyxFQUFFLFNBQVM7UUFDZCxHQUFHLEVBQUUsU0FBUztLQUNmO0lBQ0QsS0FBSyxFQUFFO1FBQ0wsRUFBRSxFQUFFLFNBQVM7UUFDYixHQUFHLEVBQUUsU0FBUztRQUNkLEdBQUcsRUFBRSxTQUFTO1FBQ2QsR0FBRyxFQUFFLFNBQVM7UUFDZCxHQUFHLEVBQUUsU0FBUztRQUNkLEdBQUcsRUFBRSxTQUFTO1FBQ2QsR0FBRyxFQUFFLFNBQVM7UUFDZCxHQUFHLEVBQUUsU0FBUztRQUNkLEdBQUcsRUFBRSxTQUFTO1FBQ2QsR0FBRyxFQUFFLFNBQVM7S0FDZjtJQUNELElBQUksRUFBRTtRQUNKLEVBQUUsRUFBRSxTQUFTO1FBQ2IsR0FBRyxFQUFFLFNBQVM7UUFDZCxHQUFHLEVBQUUsU0FBUztRQUNkLEdBQUcsRUFBRSxTQUFTO1FBQ2QsR0FBRyxFQUFFLFNBQVM7UUFDZCxHQUFHLEVBQUUsU0FBUztRQUNkLEdBQUcsRUFBRSxTQUFTO1FBQ2QsR0FBRyxFQUFFLFNBQVM7UUFDZCxHQUFHLEVBQUUsU0FBUztRQUNkLEdBQUcsRUFBRSxTQUFTO0tBQ2Y7SUFDRCxJQUFJLEVBQUU7UUFDSixFQUFFLEVBQUUsU0FBUztRQUNiLEdBQUcsRUFBRSxTQUFTO1FBQ2QsR0FBRyxFQUFFLFNBQVM7UUFDZCxHQUFHLEVBQUUsU0FBUztRQUNkLEdBQUcsRUFBRSxTQUFTO1FBQ2QsR0FBRyxFQUFFLFNBQVM7UUFDZCxHQUFHLEVBQUUsU0FBUztRQUNkLEdBQUcsRUFBRSxTQUFTO1FBQ2QsR0FBRyxFQUFFLFNBQVM7UUFDZCxHQUFHLEVBQUUsU0FBUztLQUNmO0lBQ0QsSUFBSSxFQUFFO1FBQ0osRUFBRSxFQUFFLFNBQVM7UUFDYixHQUFHLEVBQUUsU0FBUztRQUNkLEdBQUcsRUFBRSxTQUFTO1FBQ2QsR0FBRyxFQUFFLFNBQVM7UUFDZCxHQUFHLEVBQUUsU0FBUztRQUNkLEdBQUcsRUFBRSxTQUFTO1FBQ2QsR0FBRyxFQUFFLFNBQVM7UUFDZCxHQUFHLEVBQUUsU0FBUztRQUNkLEdBQUcsRUFBRSxTQUFTO1FBQ2QsR0FBRyxFQUFFLFNBQVM7S0FDZjtJQUNELE1BQU0sRUFBRTtRQUNOLEVBQUUsRUFBRSxTQUFTO1FBQ2IsR0FBRyxFQUFFLFNBQVM7UUFDZCxHQUFHLEVBQUUsU0FBUztRQUNkLEdBQUcsRUFBRSxTQUFTO1FBQ2QsR0FBRyxFQUFFLFNBQVM7UUFDZCxHQUFHLEVBQUUsU0FBUztRQUNkLEdBQUcsRUFBRSxTQUFTO1FBQ2QsR0FBRyxFQUFFLFNBQVM7UUFDZCxHQUFHLEVBQUUsU0FBUztRQUNkLEdBQUcsRUFBRSxTQUFTO0tBQ2Y7SUFDRCxJQUFJLEVBQUU7UUFDSixFQUFFLEVBQUUsU0FBUztRQUNiLEdBQUcsRUFBRSxTQUFTO1FBQ2QsR0FBRyxFQUFFLFNBQVM7UUFDZCxHQUFHLEVBQUUsU0FBUztRQUNkLEdBQUcsRUFBRSxTQUFTO1FBQ2QsR0FBRyxFQUFFLFNBQVM7UUFDZCxHQUFHLEVBQUUsU0FBUztRQUNkLEdBQUcsRUFBRSxTQUFTO1FBQ2QsR0FBRyxFQUFFLFNBQVM7UUFDZCxHQUFHLEVBQUUsU0FBUztLQUNmO0lBQ0QsSUFBSSxFQUFFO1FBQ0osS0FBSyxFQUFFLFNBQVM7UUFDaEIsS0FBSyxFQUFFLFNBQVM7UUFDaEIsY0FBYyxFQUFFLFNBQVM7UUFDekIsUUFBUSxFQUFFLFNBQVM7UUFDbkIsUUFBUSxFQUFFLFNBQVM7UUFDbkIsVUFBVSxFQUFFLFNBQVM7UUFDckIsYUFBYSxFQUFFLFNBQVM7UUFDeEIsYUFBYSxFQUFFLFNBQVM7UUFDeEIsV0FBVyxFQUFFLFNBQVM7UUFDdEIsT0FBTyxFQUFFLFNBQVM7UUFDbEIsV0FBVyxFQUFFLFNBQVM7UUFDdEIsU0FBUyxFQUFFLFNBQVM7UUFDcEIsVUFBVSxFQUFFLFNBQVM7UUFDckIsSUFBSSxFQUFFLFNBQVM7UUFDZixTQUFTLEVBQUUsU0FBUztRQUNwQixJQUFJLEVBQUUsU0FBUztRQUNmLEtBQUssRUFBRSxTQUFTO1FBQ2hCLE1BQU0sRUFBRSxTQUFTO1FBQ2pCLFlBQVksRUFBRSxTQUFTO1FBQ3ZCLFNBQVMsRUFBRSxTQUFTO1FBQ3BCLGNBQWMsRUFBRSxTQUFTO1FBQ3pCLFdBQVcsRUFBRSxTQUFTO1FBQ3RCLElBQUksRUFBRSxTQUFTO1FBQ2YsWUFBWSxFQUFFLFNBQVM7UUFDdkIsTUFBTSxFQUFFLFNBQVM7UUFDakIsU0FBUyxFQUFFLFNBQVM7UUFDcEIsYUFBYSxFQUFFLFNBQVM7UUFDeEIsUUFBUSxFQUFFLFNBQVM7UUFDbkIsTUFBTSxFQUFFLFNBQVM7UUFDakIsU0FBUyxFQUFFLFNBQVM7UUFDcEIsU0FBUyxFQUFFLFNBQVM7UUFDcEIsU0FBUyxFQUFFLFNBQVM7UUFDcEIsS0FBSyxFQUFFLFNBQVM7UUFDaEIsVUFBVSxFQUFFLFNBQVM7UUFDckIsTUFBTSxFQUFFLFNBQVM7S0FDbEI7Q0FDRixDQUFBIiwic291cmNlc0NvbnRlbnQiOlsiZXhwb3J0IGRlZmF1bHQge1xuICBibGFjazogJyMwMDAwMDAnLFxuICB3aGl0ZTogJyNGRkZGRkYnLFxuICBncmF5OiB7XG4gICAgNTA6ICcjRjdGQUZDJyxcbiAgICAxMDA6ICcjRURGMkY3JyxcbiAgICAyMDA6ICcjRTJFOEYwJyxcbiAgICAzMDA6ICcjQ0JENUUwJyxcbiAgICA0MDA6ICcjQTBBRUMwJyxcbiAgICA1MDA6ICcjNzE4MDk2JyxcbiAgICA2MDA6ICcjNEE1NTY4JyxcbiAgICA3MDA6ICcjMkQzNzQ4JyxcbiAgICA4MDA6ICcjMUEyMDJDJyxcbiAgICA5MDA6ICcjMTcxOTIzJyxcbiAgfSxcbiAgcmVkOiB7XG4gICAgNTA6ICcjRkRFOEU4JyxcbiAgICAxMDA6ICcjRjlCRUJFJyxcbiAgICAyMDA6ICcjRjU5MzkzJyxcbiAgICAzMDA6ICcjRjE2OTY5JyxcbiAgICA0MDA6ICcjRUUzRjNGJyxcbiAgICA1MDA6ICcjRjkxNjE2JyxcbiAgICA2MDA6ICcjQkIxMTExJyxcbiAgICA3MDA6ICcjOEMwRDBEJyxcbiAgICA4MDA6ICcjNUUwODA4JyxcbiAgICA5MDA6ICcjMkYwNDA0JyxcbiAgfSxcbiAgb3JhbmdlOiB7XG4gICAgNTA6ICcjRkVFRkU3JyxcbiAgICAxMDA6ICcjRkJEM0JDJyxcbiAgICAyMDA6ICcjRjlCNzkwJyxcbiAgICAzMDA6ICcjRjY5QTY1JyxcbiAgICA0MDA6ICcjRjM3RTM5JyxcbiAgICA1MDA6ICcjRjE2MjBFJyxcbiAgICA2MDA6ICcjQzE0RTBCJyxcbiAgICA3MDA6ICcjOTEzQjA4JyxcbiAgICA4MDA6ICcjNjAyNzA2JyxcbiAgICA5MDA6ICcjMzAxNDAzJyxcbiAgfSxcbiAgeWVsbG93OiB7XG4gICAgNTA6ICcjRkVGQkU2JyxcbiAgICAxMDA6ICcjRkNGM0JBJyxcbiAgICAyMDA6ICcjRkJFQjhFJyxcbiAgICAzMDA6ICcjRjlFMzYyJyxcbiAgICA0MDA6ICcjRjdEQjM2JyxcbiAgICA1MDA6ICcjRjdEOTJCJyxcbiAgICA2MDA6ICcjQzVBOTA3JyxcbiAgICA3MDA6ICcjOTM3RjA2JyxcbiAgICA4MDA6ICcjNjI1NDA0JyxcbiAgICA5MDA6ICcjMzEyQTAyJyxcbiAgfSxcbiAgZ3JlZW46IHtcbiAgICA1MDogJyNFQUZCRUYnLFxuICAgIDEwMDogJyNDM0Y0RDInLFxuICAgIDIwMDogJyM5Q0VEQjQnLFxuICAgIDMwMDogJyM3NUU1OTcnLFxuICAgIDQwMDogJyM0RkRFN0EnLFxuICAgIDUwMDogJyMyRUQ4NjEnLFxuICAgIDYwMDogJyMyMEFDNEEnLFxuICAgIDcwMDogJyMxODgxMzgnLFxuICAgIDgwMDogJyMxMDU2MjUnLFxuICAgIDkwMDogJyMwODJCMTMnLFxuICB9LFxuICB0ZWFsOiB7XG4gICAgNTA6ICcjRTZGRkZBJyxcbiAgICAxMDA6ICcjQjJGNUVBJyxcbiAgICAyMDA6ICcjODFFNkQ5JyxcbiAgICAzMDA6ICcjNEZEMUM1JyxcbiAgICA0MDA6ICcjMzhCMkFDJyxcbiAgICA1MDA6ICcjMzE5Nzk1JyxcbiAgICA2MDA6ICcjMkM3QTdCJyxcbiAgICA3MDA6ICcjMjg1RTYxJyxcbiAgICA4MDA6ICcjMjM0RTUyJyxcbiAgICA5MDA6ICcjMUQ0MDQ0JyxcbiAgfSxcbiAgYmx1ZToge1xuICAgIDUwOiAnI0U2RUJGRScsXG4gICAgMTAwOiAnI0JBQzhGRCcsXG4gICAgMjAwOiAnIzhFQTVGQicsXG4gICAgMzAwOiAnIzYxODJGQScsXG4gICAgNDAwOiAnIzI2NkNEMycsXG4gICAgNTAwOiAnIzA5M0NGNicsXG4gICAgNjAwOiAnIzA3MzBDNScsXG4gICAgNzAwOiAnIzA1MjM5MScsXG4gICAgODAwOiAnIzAzMTg2MycsXG4gICAgOTAwOiAnIzAyMEMzMScsXG4gIH0sXG4gIGN5YW46IHtcbiAgICA1MDogJyNFNUZERkYnLFxuICAgIDEwMDogJyNCOEY4RkYnLFxuICAgIDIwMDogJyM4QUY0RkYnLFxuICAgIDMwMDogJyM1Q0YwRkYnLFxuICAgIDQwMDogJyMyRUVDRkYnLFxuICAgIDUwMDogJyMwMEUyRjknLFxuICAgIDYwMDogJyMwMEI5Q0MnLFxuICAgIDcwMDogJyMwMDhCOTknLFxuICAgIDgwMDogJyMwMDVENjYnLFxuICAgIDkwMDogJyMwMDJFMzMnLFxuICB9LFxuICBwdXJwbGU6IHtcbiAgICA1MDogJyNGQkU5RkInLFxuICAgIDEwMDogJyNGNUMyRjUnLFxuICAgIDIwMDogJyNFRTlCRUUnLFxuICAgIDMwMDogJyNFNzczRTcnLFxuICAgIDQwMDogJyNFMTRDRTEnLFxuICAgIDUwMDogJyNEQTI1REEnLFxuICAgIDYwMDogJyNBNTFDQTUnLFxuICAgIDcwMDogJyM4MzE2ODMnLFxuICAgIDgwMDogJyM1NzBGNTcnLFxuICAgIDkwMDogJyMyQzA3MkMnLFxuICB9LFxuICBwaW5rOiB7XG4gICAgNTA6ICcjRkZGNUY3JyxcbiAgICAxMDA6ICcjRkVEN0UyJyxcbiAgICAyMDA6ICcjRkJCNkNFJyxcbiAgICAzMDA6ICcjRjY4N0IzJyxcbiAgICA0MDA6ICcjRUQ2NEE2JyxcbiAgICA1MDA6ICcjRDUzRjhDJyxcbiAgICA2MDA6ICcjQjgzMjgwJyxcbiAgICA3MDA6ICcjOTcyNjZEJyxcbiAgICA4MDA6ICcjNzAyNDU5JyxcbiAgICA5MDA6ICcjNTIxQjQxJyxcbiAgfSxcbiAgYXBleDoge1xuICAgIGJsYWNrOiAnIzAwMDAwMCcsXG4gICAgY29yYWw6ICcjRUUzRjNGJyxcbiAgICBjb3JuZmxvd2VyQmx1ZTogJyMyNjZjZDMnLFxuICAgIGRhcmtDeWFuOiAnIzAwOGI5OScsXG4gICAgZGFya0dyYXk6ICcjQTBBRUMwJyxcbiAgICBkYXJrT3JhbmdlOiAnI0YxNjIwRScsXG4gICAgZGFya1NsYXRlQmx1ZTogJyMwNTIzOTEnLFxuICAgIGRhcmtTbGF0ZUdyYXk6ICcjNzE4MDk2JyxcbiAgICBkZWVwU2t5Qmx1ZTogJyMwMEUyRjknLFxuICAgIGRpbUdyYXk6ICcjNEE1NTY4JyxcbiAgICBmb3Jlc3RHcmVlbjogJyMxODgxMzgnLFxuICAgIGdhaW5zYm9ybzogJyNFREYyRjcnLFxuICAgIGdob3N0V2hpdGU6ICcjRjdGQUZDJyxcbiAgICBnb2xkOiAnI0Y3RDkyQicsXG4gICAgZ29sZGVuUm9kOiAnI0Y2OUE2NScsXG4gICAgZ3JheTogJyM3MTgwOTYnLFxuICAgIGdyZWVuOiAnIzIwQUM0QScsXG4gICAgaW5kaWdvOiAnIzgzMTY4MycsXG4gICAgbGVtb25DaGlmZm9uOiAnI0ZDRjNCQScsXG4gICAgbGlnaHRHcmF5OiAnI0UyRThGMCcsXG4gICAgbGlnaHRTbGF0ZUdyYXk6ICcjQTBBRUMwJyxcbiAgICBsaWdodFllbGxvdzogJyNGRUZCRTYnLFxuICAgIGxpbms6ICcjMjY2Y2QzJyxcbiAgICBtaWRuaWdodEJsdWU6ICcjMDAwMDAwJyxcbiAgICBvcmFuZ2U6ICcjRjM3RTM5JyxcbiAgICBvcmFuZ2VSZWQ6ICcjRjkxNjE2JyxcbiAgICByZWJlY2NhUHVycGxlOiAnI0E1MUNBNScsXG4gICAgc2VhR3JlZW46ICcjMkM3QTdCJyxcbiAgICBzaWx2ZXI6ICcjQ0JENUUwJyxcbiAgICBzbGF0ZUJsdWU6ICcjNkE1QUNEJyxcbiAgICBzbGF0ZUdyYXk6ICcjMDczMEM1JyxcbiAgICBzdGVlbEJsdWU6ICcjMDBCOUNDJyxcbiAgICB3aGl0ZTogJyNGRkZGRkYnLFxuICAgIHdoaXRlU21va2U6ICcjRjdGQUZDJyxcbiAgICB5ZWxsb3c6ICcjRkJFQjhFJyxcbiAgfSxcbn1cbiJdfQ==